(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialize(root) {
    if (root.dataset.communityInitialized) return;
    const stage = root.querySelector('[data-gallery-stage]');
    const slides = [...root.querySelectorAll('[data-gallery-slide]')];
    if (!stage || !slides.length) return;
    root.dataset.communityInitialized = 'true';

    const dots = [...root.querySelectorAll('[data-gallery-dot]')];
    const position = root.querySelector('[data-gallery-position]');
    const pauseButton = root.querySelector('[data-gallery-pause]');
    let current = 0;
    let timer = null;
    let hoverPaused = false;
    let focusPaused = false;
    let userPaused = false;

    function update(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const offset = (i - current + slides.length) % slides.length;
        const state = offset === 0 ? 'active' : offset === slides.length - 1 ? 'previous' : offset === 1 ? 'next' : 'hidden';
        slide.dataset.position = state;
        slide.setAttribute('aria-hidden', String(state === 'hidden'));
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
      if (position) position.textContent = `${current + 1} / ${slides.length}`;
    }

    function stopTimer() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function startTimer() {
      stopTimer();
      if (reducedMotion.matches || hoverPaused || focusPaused || userPaused || slides.length < 2) return;
      timer = window.setInterval(() => update(current + 1), 5000);
    }

    function goTo(index) {
      update(index);
      startTimer();
    }

    const previous = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    if (previous) previous.addEventListener('click', () => goTo(current - 1));
    if (next) next.addEventListener('click', () => goTo(current + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    stage.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    root.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') {
        hoverPaused = true;
        stopTimer();
      }
    });
    root.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') {
        hoverPaused = false;
        startTimer();
      }
    });
    root.addEventListener('focusin', () => {
      focusPaused = true;
      stopTimer();
    });
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) {
        focusPaused = false;
        startTimer();
      }
    });
    if (pauseButton) {
      pauseButton.addEventListener('click', () => {
        userPaused = !userPaused;
        pauseButton.textContent = userPaused ? 'Play' : 'Pause';
        pauseButton.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
        pauseButton.setAttribute('aria-pressed', String(userPaused));
        startTimer();
      });
    }
    slides.forEach((slide, i) => {
      slide.addEventListener('shopify:block:select', () => goTo(i));
    });

    update(0);
    startTimer();
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-gf-community-carousel]').forEach(initialize);
  }

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
